<span class="status">
  @switch (status) {
    @case (UserStatus.Active) {
      <img alt="" src="/assets/default/input-approved.svg">
    }
    @case (UserStatus.Disabled) {
      <img alt="" src="/assets/default/input-error.svg">
    }
    @case (UserStatus.Pending) {
      <img alt="" src="/assets/default/alert.svg">
    }
  }
  {{ UserStatusPresentation(status) }}
</span>
